import Vue from "vue";

export const requestLoadingState = Vue.observable({
  visible: false
});

